import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconMinusSvg } from './IconMinusSvg';

export type IconMinusProps = UseIconProps;

export function IconMinus(props: IconMinusProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconMinusSvg} {...iconProps} />;
}
